"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.medianMeasure = void 0;
const convert_measure_1 = require("../convert-measure/convert-measure");
function medianMeasure(...items) {
    if (items.length === 0) {
        throw new RangeError('Cannot determine median of empty array.');
    }
    const template = items.find((item) => item.value != null) ?? items[0];
    const normalized = items
        .filter((item) => item.value != null)
        .map((item) => {
        if (item.unit === template.unit) {
            return item;
        }
        if (convert_measure_1.convertMeasure.canConvert(item, template.unit)) {
            return (0, convert_measure_1.convertMeasure)(item, template.unit);
        }
        throw new TypeError(`Expected measure with unit '${template.unit}', but got '${item.unit}'.`);
    });
    if (normalized.length === 0) {
        return template;
    }
    normalized.sort((a, b) => a.value - b.value);
    if (normalized.length % 2 === 1) {
        const offset = Math.floor(normalized.length / 2);
        return {
            ...template,
            value: normalized[offset].value,
        };
    }
    const offset = normalized.length / 2;
    return {
        ...template,
        value: (normalized[offset - 1].value + normalized[offset].value) / 2,
    };
}
exports.medianMeasure = medianMeasure;
